import {
    Box,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography,
} from "@mui/material";
import React from "react";
import styles from "../../styles/pages/user/content-buyer-purchasevideo.module.scss";
import assest from "../../json/assest";
// import Image from 'next/image'
import { Link } from "react-router-dom";
import ExclamationIcon from "../../ui/Icons/ExclamationIcon";
import PerfectScrollbar from "react-perfect-scrollbar";
import "react-perfect-scrollbar/dist/css/styles.css";
import iconOops from "../../public/assets/images/icon-oops.svg";
import { getAbsoluteImageURI } from "../../lib/functions/utils.lib";
import { useState } from "react";
import VideoPageFullModal from "../VideoPages/pages/VideoPageFullModal";
import WatchVideoModal from "../VideoPages/pages/WatchVideoModal";
import { Button } from "antd";

const rows = [
    {
        vsid: "13194",
        thumbnail: `${assest.tabthumbnail1}`,
        title: "Boy Jumped with the Umbrella and the Wind Almost Sent Him Flying Too Far Away",
        ownerName: "John Smith",
        emailAddress: "johnsmith@gmail.com",
        purchaseAmount: "120",
        purchaseDate: "September 26, 2019",
        purchaseTime: "at 05:45:23 AM UTC",
        type: "redDot",
    },
    {
        vsid: "13194",
        thumbnail: `${assest.tabthumbnail2}`,
        title: "Rabbit on fence",
        ownerName: "John Smith",
        emailAddress: "johnsmith@gmail.com",
        purchaseAmount: "120",
        purchaseDate: "September 26, 2019",
        purchaseTime: "at 05:45:23 AM UTC",
        type: "",
    },
    {
        vsid: "13194",
        thumbnail: `${assest.tabthumbnail3}`,
        title: "Rabbit on fence",
        ownerName: "John Smith",
        emailAddress: "johnsmith@gmail.com",
        purchaseAmount: "120",
        purchaseDate: "August 6, 2019",
        purchaseTime: "at 05:45:23 AM UTC",
        type: "exclamation",
    },
    {
        vsid: "13194",
        thumbnail: `${assest.tabthumbnail4}`,
        title: "Rabbit on fence",
        ownerName: "John Smith",
        emailAddress: "johnsmith@gmail.com",
        purchaseAmount: "120",
        purchaseDate: "September 26, 2019",
        purchaseTime: "at 05:45:23 AM UTC",
        type: "",
    },
    {
        vsid: "13194",
        thumbnail: `${assest.tabthumbnail5}`,
        title: "Girl Tries Hitting a Car with Her Hand at a Traffic Light",
        ownerName: "John Smith",
        emailAddress: "johnsmith@gmail.com",
        purchaseAmount: "120",
        purchaseDate: "June 26, 2019",
        purchaseTime: "at 05:45:23 AM UTC",
        type: "",
    },
    {
        vsid: "13194",
        thumbnail: `${assest.tabthumbnail6}`,
        title: "Girl Gets Surprised with a Baby Yoda Toy That She Wanted for So Long",
        ownerName: "John Smith",
        emailAddress: "johnsmith@gmail.com",
        purchaseAmount: "120",
        purchaseDate: "January 26, 2019",
        purchaseTime: "at 05:45:23 AM UTC",
        type: "exclamation",
    },
    {
        vsid: "13194",
        thumbnail: `${assest.tabthumbnail7}`,
        title: "Rabbit on fence",
        ownerName: "John Smith",
        emailAddress: "johnsmith@gmail.com",
        purchaseAmount: "120",
        purchaseDate: "October 26, 2019",
        purchaseTime: "at 05:45:23 AM UTC",
        type: "redDot",
    },
    {
        vsid: "13194",
        thumbnail: `${assest.tabthumbnail8}`,
        title: "Rabbit on fence",
        ownerName: "John Smith",
        emailAddress: "johnsmith@gmail.com",
        purchaseAmount: "120",
        purchaseDate: "September 26, 2019",
        purchaseTime: "at 05:45:23 AM UTC",
        type: "",
    },
    {
        vsid: "13194",
        thumbnail: `${assest.tabthumbnail9}`,
        title: "Rabbit on fence",
        ownerName: "John Smith",
        emailAddress: "johnsmith@gmail.com",
        purchaseAmount: "120",
        purchaseDate: "April 26, 2019",
        purchaseTime: "at 05:45:23 AM UTC",
        type: "",
    },
    {
        vsid: "13194",
        thumbnail: `${assest.tabthumbnail5}`,
        title: "Boy Jumped with the Umbrella and the Wind Almost Sent Him Flying Too Far Away",
        ownerName: "John Smith",
        emailAddress: "johnsmith@gmail.com",
        purchaseAmount: "120",
        purchaseDate: "March 30, 2019",
        purchaseTime: "at 05:45:23 AM UTC",
        type: "",
    },
    {
        vsid: "13194",
        thumbnail: `${assest.tabthumbnail6}`,
        title: "Rabbit on fence",
        ownerName: "John Smith",
        emailAddress: "johnsmith@gmail.com",
        purchaseAmount: "120",
        purchaseDate: "November 26, 2019",
        purchaseTime: "at 05:45:23 AM UTC",
        type: "",
    },
    {
        vsid: "13194",
        thumbnail: `${assest.tabthumbnail7}`,
        title: "Rabbit on fence",
        ownerName: "John Smith",
        emailAddress: "johnsmith@gmail.com",
        purchaseAmount: "120",
        purchaseDate: "September 26, 2019",
        purchaseTime: "at 05:45:23 AM UTC",
        type: "",
    },
    {
        vsid: "13194",
        thumbnail: `${assest.tabthumbnail8}`,
        title: "Rabbit on fence",
        ownerName: "John Smith",
        emailAddress: "johnsmith@gmail.com",
        purchaseAmount: "120",
        purchaseDate: "September 26, 2019",
        purchaseTime: "at 05:45:23 AM UTC",
        type: "",
    },
    {
        vsid: "13194",
        thumbnail: `${assest.tabthumbnail9}`,
        title: "Rabbit on fence",
        ownerName: "John Smith",
        emailAddress: "johnsmith@gmail.com",
        purchaseAmount: "120",
        purchaseDate: "September 26, 2019",
        purchaseTime: "at 05:45:23 AM UTC",
        type: "",
    },
    {
        vsid: "13194",
        thumbnail: `${assest.tabthumbnail5}`,
        title: "Rabbit on fence",
        ownerName: "John Smith",
        emailAddress: "johnsmith@gmail.com",
        purchaseAmount: "120",
        purchaseDate: "September 26, 2019",
        purchaseTime: "at 05:45:23 AM UTC",
        type: "",
    },
    {
        vsid: "13194",
        thumbnail: `${assest.tabthumbnail6}`,
        title: "Rabbit on fence",
        ownerName: "John Smith",
        emailAddress: "johnsmith@gmail.com",
        purchaseAmount: "120",
        purchaseDate: "September 26, 2019",
        purchaseTime: "at 05:45:23 AM UTC",
        type: "",
    },
    {
        vsid: "13194",
        thumbnail: `${assest.tabthumbnail7}`,
        title: "Rabbit on fence",
        ownerName: "John Smith",
        emailAddress: "johnsmith@gmail.com",
        purchaseAmount: "120",
        purchaseDate: "September 26, 2019",
        purchaseTime: "at 05:45:23 AM UTC",
        type: "",
    },
    {
        vsid: "13194",
        thumbnail: `${assest.tabthumbnail5}`,
        title: "Rabbit on fence",
        ownerName: "John Smith",
        emailAddress: "johnsmith@gmail.com",
        purchaseAmount: "120",
        purchaseDate: "September 26, 2019",
        purchaseTime: "at 05:45:23 AM UTC",
        type: "",
    },
    {
        vsid: "13194",
        thumbnail: `${assest.tabthumbnail7}`,
        title: "Rabbit on fence",
        ownerName: "John Smith",
        emailAddress: "johnsmith@gmail.com",
        purchaseAmount: "120",
        purchaseDate: "September 26, 2019",
        purchaseTime: "at 05:45:23 AM UTC",
        type: "",
    },
    {
        vsid: "13194",
        thumbnail: `${assest.tabthumbnail5}`,
        title: "Rabbit on fence",
        ownerName: "John Smith",
        emailAddress: "johnsmith@gmail.com",
        purchaseAmount: "120",
        purchaseDate: "September 26, 2019",
        purchaseTime: "at 05:45:23 AM UTC",
        type: "",
    },
];

const ContentbuyerPurchasedVideoTable = ({ videoList }) => {
    const [openModal, setOpenModal] = useState(false);
    const [openModalTwo, setOpenModalTwo] = useState(false);
    const [id, setId] = useState();

    const onOpen = (id) => {
        setId(id);
        setOpenModal(true);
    };
    const onClose = () => {
        setId();
        setOpenModal(false);
    };
    const onOpenTwo = (id) => {
        setId(id);
        setOpenModalTwo(true);
    };
    const onCloseTwo = () => {
        setId();
        setOpenModalTwo(false);
    };
    return (
        <>
            <TableContainer>
                <PerfectScrollbar className={styles.secScroll}>
                    <Table className={styles.purchaseVdotable} stickyHeader>
                        <TableHead>
                            <TableRow>
                                <TableCell className={styles.thPcvsid}>
                                    VSID
                                </TableCell>
                                <TableCell className={styles.thPcThumbnail}>
                                    Thumbnail
                                </TableCell>
                                <TableCell className={styles.thPcTitle}>
                                    Title
                                </TableCell>
                                <TableCell className={styles.thPcOwnerName}>
                                    Owner Name
                                </TableCell>
                                <TableCell className={styles.thPcEmail}>
                                    Email Address
                                </TableCell>
                                <TableCell
                                    align="center"
                                    className={styles.thPcPurchaseamount}
                                >
                                    Purchase Amount
                                </TableCell>
                                <TableCell className={styles.thPcPurchaseDate}>
                                    Purchase Date
                                </TableCell>
                                <TableCell
                                    align="center"
                                    className={styles.thPcView}
                                >
                                    View
                                </TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {videoList?.map((row) => (
                                <TableRow>
                                    <TableCell
                                        scope="row"
                                        className={styles.thPcvsid}
                                    >
                                        <Typography variant="body2">
                                            {row?.vsid}
                                            {row?.type === "redDot" ? (
                                                <span
                                                    className={styles.redDot}
                                                ></span>
                                            ) : row?.type === "exclamation" ? (
                                                <span
                                                    className={
                                                        styles.exclamationIcon
                                                    }
                                                >
                                                    <ExclamationIcon />
                                                </span>
                                            ) : null}
                                        </Typography>
                                    </TableCell>
                                    <TableCell
                                        className={styles.thPcThumbnail}
                                        onClick={() => onOpenTwo(row?.id)}
                                    >
                                        <img
                                            src={getAbsoluteImageURI(
                                                row?.thumbnail
                                            )}
                                            width={73}
                                            height={46}
                                            alt="image"
                                            className={styles.thumImg}
                                        />
                                    </TableCell>
                                    <TableCell className={styles.thPcTitle}>
                                        <Typography
                                            variant="body1"
                                            className={styles.tableTitle}
                                        >
                                            {row?.title
                                                ? row?.title?.length > 20
                                                    ? row?.title?.slice(17) +
                                                      "..."
                                                    : row?.title
                                                : "N/A"}
                                        </Typography>
                                    </TableCell>
                                    <TableCell className={styles.thPcOwnerName}>
                                        <Typography variant="body2">
                                            {row?.first_name} {row?.last_name}
                                        </Typography>
                                    </TableCell>
                                    <TableCell className={styles.thPcEmail}>
                                        <Typography
                                            variant="body2"
                                            className={styles.emailTxt}
                                        >
                                            {row?.email}
                                        </Typography>
                                    </TableCell>
                                    <TableCell
                                        align="center"
                                        className={styles.thPcPurchaseamount}
                                    >
                                        <Typography variant="body2">
                                            ${row?.price}
                                        </Typography>
                                    </TableCell>
                                    <TableCell
                                        className={styles.thPcPurchaseDate}
                                    >
                                        <Typography variant="body2">
                                            {row?.purchaseDate}
                                            <br /> {row?.purchaseTime}
                                        </Typography>
                                    </TableCell>
                                    <TableCell
                                        align="center"
                                        className={styles.thPcView}
                                    >
                                        <Button
                                            onClick={() => onOpen(row?.id)}
                                            className={
                                                row?.type === "exclamation"
                                                    ? `${styles.redExclamation}`
                                                    : `${styles.StyledeyeIcon}`
                                            }
                                        >
                                            <img
                                                src={assest.IconView}
                                                width={16}
                                                height={16}
                                                alt="icon"
                                            />
                                        </Button>
                                    </TableCell>
                                </TableRow>
                            ))}
                            {/* <TableRow className={styles.dateRangeNoresult}>
                                <TableCell colSpan={8} align='center'>
                                    <Box className={styles.noFilter}>
                                        <figure>
                                            <img src={iconOops} alt="" />
                                        </figure>
                                        <Typography variant='body1'>We couldn't find any pending videos within the specified date range.</Typography>
                                    </Box>
                                </TableCell>
                            </TableRow> */}
                        </TableBody>
                    </Table>
                </PerfectScrollbar>
            </TableContainer>
            <VideoPageFullModal
                onClose={onClose}
                open={openModal}
                id={id}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                className="videoPageModal"
            />
            <WatchVideoModal
                onClose={onCloseTwo}
                open={openModalTwo}
                id={id}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                className="videoPageModal"
            />
        </>
    );
};

export default ContentbuyerPurchasedVideoTable;
